/**
 * @generated SignedSource<<eb8d8b3b6a323044fe7bf135d706e406>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateCateringOptionInput = {
  displayInSearch?: boolean | null;
  etgKey?: string | null;
  name: string;
};
export type CateringOptionsListAddMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateCateringOptionInput;
};
export type CateringOptionsListAddMutation$data = {
  readonly createCateringOption: {
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"CateringOptionsListRow_cateringOption">;
    };
  };
};
export type CateringOptionsListAddMutation = {
  response: CateringOptionsListAddMutation$data;
  variables: CateringOptionsListAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CateringOptionsListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CateringOptionNode",
        "kind": "LinkedField",
        "name": "createCateringOption",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CateringOption",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CateringOptionsListRow_cateringOption"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CateringOptionsListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CateringOptionNode",
        "kind": "LinkedField",
        "name": "createCateringOption",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CateringOption",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "etgKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayInSearch",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletable",
                    "storageKey": null
                  }
                ],
                "type": "Entity",
                "abstractKey": "__isEntity"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "node",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "CateringOptionEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2fe473b50e87d5bbad5cc9bf87b37487",
    "id": null,
    "metadata": {},
    "name": "CateringOptionsListAddMutation",
    "operationKind": "mutation",
    "text": "mutation CateringOptionsListAddMutation(\n  $input: CreateCateringOptionInput!\n) {\n  createCateringOption(input: $input) {\n    node {\n      ...CateringOptionsListRow_cateringOption\n      id\n    }\n  }\n}\n\nfragment CateringOptionsListRow_cateringOption on CateringOption {\n  id\n  name\n  etgKey\n  displayInSearch\n  ...SortableEntityTableRow_entity\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment SortableEntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  ...EntityTableRow_entity\n}\n"
  }
};
})();

(node as any).hash = "29c5b9377b65733f6b502130239f1c0c";

export default node;
